<section class="dashboard-page">
  <aside class="sidebar">
    <img class="brand-logo" src="assets/dashboard/logoApp.svg" alt="AutoInsight logo" />
    <button class="manage-btn" type="button" (click)="onManageVehicles()">Manage</button>
    <button *ngIf="isMechanicView" class="manage-btn" type="button" (click)="onOpenMaintenanceReservations()">
      Reservations
    </button>

    <section class="mileage-card">
      <h2>Mileage</h2>
      <p>Update durability calculations for the selected vehicle.</p>
      <p class="mileage-current" *ngIf="model?.currentOdometerKm !== undefined && model?.currentOdometerKm !== null">
        Current: {{ model?.currentOdometerKm | number }} km
      </p>
      <input
        type="text"
        inputmode="numeric"
        aria-label="Kilometers to add"
        placeholder="Kilometers to add"
        [(ngModel)]="mileageInput"
        [disabled]="mileageSaving || mileageRefreshing" />
      <button type="button" (click)="onAddMileageToVehicle()" [disabled]="mileageSaving || mileageRefreshing">
        {{ mileageSaving ? 'Saving...' : (mileageRefreshing ? 'Refreshing...' : 'Add to Vehicle') }}
      </button>
      <p class="mileage-message error" *ngIf="mileageErrorMessage">{{ mileageErrorMessage }}</p>
      <p class="mileage-message success" *ngIf="!mileageErrorMessage && mileageSuccessMessage">{{ mileageSuccessMessage }}</p>
    </section>
  </aside>

  <main class="dashboard-main">
    <div *ngIf="loading && !model" class="state">Loading dashboard...</div>
    <div *ngIf="!loading && !model && errorMessage" class="state error">{{ errorMessage }}</div>

    <ng-container *ngIf="model as vm">
      <div *ngIf="vm.emptyStateMessage" class="state warning">{{ vm.emptyStateMessage }}</div>

      <section class="panel panel-performance">
        <h2 class="section-title">Performance &amp; Safety</h2>
        <div class="metric-grid metric-grid-top">
          <article class="metric metric-main">
            <h3>Tire Tread</h3>
            <div class="metric-icon-shell"><img src="assets/dashboard/iconTire.svg" alt="Tire tread" /></div>
            <p class="metric-value">{{ vm.performanceSafety.tireTreadPercent }}%</p>
          </article>

          <article class="metric metric-main">
            <h3>Acceleration</h3>
            <div class="metric-icon-shell"><img src="assets/dashboard/iconAcceleration.svg" alt="Acceleration" /></div>
            <p class="metric-value">{{ vm.performanceSafety.accelerationZeroToHundredSeconds | number: '1.0-0' }} km/h</p>
          </article>

          <article class="metric metric-main">
            <h3>Top Speed</h3>
            <div class="metric-icon-shell"><img src="assets/dashboard/iconSpeed.svg" alt="Top speed" /></div>
            <p class="metric-value">{{ vm.performanceSafety.topSpeedKmh }} km/h</p>
          </article>

          <article class="metric metric-main fuel-card">
            <h3>Fuel Efficiencies</h3>
            <div class="metric-icon-shell"><img src="assets/dashboard/iconFuel.svg" alt="Fuel efficiencies" /></div>
            <p>City: {{ vm.fuelEfficiency.cityKmPerL | number: '1.0-0' }} km/L</p>
            <p>Highway: {{ vm.fuelEfficiency.highwayKmPerL | number: '1.0-0' }} km/L</p>
          </article>
        </div>
      </section>
    </ng-container>
  </main>

  <ng-container *ngIf="model as vm">
    <section class="panel panel-maintenance">
      <div class="panel-head">
        <h2 class="section-title">Upcoming Maintenance</h2>
        <button class="view-all-link" type="button" (click)="goToMaintenanceParts()">View All</button>
      </div>
      <div class="metric-grid metric-grid-bottom">
        <button
          *ngFor="let item of maintenanceDisplayItems"
          class="metric metric-maint metric-maint-button"
          type="button"
          (click)="openMaintenancePart(item)">
          <div class="maint-icon-shell">
            <img
              [src]="maintenanceIcon(item.name)"
              [alt]="displayMaintenanceName(item.name)"
              [class.spark-icon]="isCompactMaintenanceIcon(item.name)" />
          </div>
          <h3>{{ displayMaintenanceName(item.name) }}</h3>
          <p class="metric-value">{{ item.remainingLifePercent }}%</p>
        </button>
      </div>
    </section>
  </ng-container>
</section>
